import { DEFAULT_LEAD_PROVIDER_SERVICE, } from '../hooks/useGetLinkSearchParams';
const getLeadFormParamsByAppName = (appName, featureOrigin) => ({ modelKey, modelYear, language, dealerCode, providerService, trimKey, transmissionKey, exteriorColorKey, interiorColorKey, }) => ({
    modelYear,
    model: modelKey,
    trim: trimKey,
    transmission: transmissionKey,
    exteriorColor: exteriorColorKey,
    interiorColor: interiorColorKey,
    lang: language,
    dealerCode,
    providerService,
    leadProviderService: `${featureOrigin} ${appName} ${DEFAULT_LEAD_PROVIDER_SERVICE}`,
});
export default getLeadFormParamsByAppName;
